import axios from "./axiosInstance/rdd";

const predict = payload => {
  const body = JSON.stringify(payload);
  const data = new URLSearchParams({ Data: body })
    .toString()
    .replace("+", "%20");
  return axios.post(`/renalfailure_predict_json?${data}`);
};

const rddApi = { predict };

export default rddApi;
